// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === Layout fix === */
.vessel-registration-layout {
    display: flex;
    height: 100vh;
    background-color: #f5f8fc;
}

    /* Sidebar should have fixed width */
    .vessel-registration-layout .sidebar {
        width: 250px;
        flex-shrink: 0;
        background-color: #e6ddcf;
        height: 100vh;
        overflow-y: auto;
    }

    /* Main section should grow to fill */
    .vessel-registration-layout .main-content {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        min-height: 100vh;
        padding: 16px 24px;
        box-sizing: border-box;
        overflow-y: auto;
    }

/* === Tabs === */
.tab-navigation {
    display: flex;
    flex-wrap: wrap;
    margin: 16px 0;
    gap: 10px;
}

.tab-item {
    padding: 10px 16px;
    background: #fff;
    border-radius: 4px;
    cursor: pointer;
    border: 1px solid #ddd;
    font-weight: 500;
    font-size: 14px;
}

    .tab-item.active {
        background: #16375c;
        color: #fff;
        border-color: #16375c;
    }

.tab-content {
    background: #fff;
    padding: 24px;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    margin-bottom: 30px;
}

.tab-buttons {
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
    gap: 12px;
}

/* === Buttons === */
.btn-primary {
    background-color: #16375c;
    color: white;
    padding: 8px 20px;
    border: none;
    border-radius: 4px;
    font-weight: 600;
    cursor: pointer;
}

.btn-secondary {
    background-color: #e0e0e0;
    color: #333;
    padding: 8px 20px;
    border: none;
    border-radius: 4px;
    font-weight: 600;
    cursor: pointer;
}

/* Responsive Fixes */
@media (max-width: 768px) {
    .tab-item {
        flex: 1 1 100%;
        text-align: center;
    }

    .tab-buttons {
        flex-direction: column;
        align-items: stretch;
    }
}
.review-section {
    margin-bottom: 32px;
    padding-bottom: 16px;
    border-bottom: 1px solid #ccc;
}

    .review-section h3 {
        font-size: 20px;
        color: #16375c;
        margin-bottom: 12px;
        border-left: 4px solid #16375c;
        padding-left: 12px;
    }

.review-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 12px 24px;
}

.review-field {
    font-size: 14px;
}

.review-label {
    font-weight: 600;
    color: #333;
}

.review-value {
    color: #555;
}
.main-layout {
    display: flex;
    flex-direction: row;
    min-height: 100vh;
}

.main-content {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    background-color: #f4f7fa;
    padding: 20px;
    overflow-x: hidden;
}

.content-card {
    background: white;
    padding: 20px;
    border-radius: 8px;
    margin-top: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}

.filter-row {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 20px;
}

    .filter-row input,
    .filter-row select {
        padding: 8px 12px;
        min-width: 180px;
        border: 1px solid #ccc;
        border-radius: 4px;
    }

.vessel-table {
    width: 100%;
    border-collapse: collapse;
}

    .vessel-table th,
    .vessel-table td {
        padding: 10px;
        border: 1px solid #ccc;
        text-align: left;
        font-size: 14px;
    }

    .vessel-table th {
        background-color: #f0f0f0;
        font-weight: 600;
    }

.pagination-controls {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    margin-top: 20px;
}
.vessel-list-page {
    padding: 1rem 2rem;
    background-color: #f9f9f9;
}

.filter-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 1rem;
}

    .filter-grid input,
    .filter-grid select {
        padding: 8px;
        min-width: 180px;
        font-size: 14px;
    }

.vessel-table {
    width: 100%;
    border-collapse: collapse;
    background-color: #fff;
}

    .vessel-table th, .vessel-table td {
        border: 1px solid #ddd;
        padding: 10px;
        font-size: 14px;
        text-align: left;
    }

    .vessel-table th {
        background-color: #f0f0f0;
        font-weight: bold;
    }

    .vessel-table tbody tr:hover {
        background-color: #f5f5f5;
    }
.vessel-list-layout {
    display: flex;
    min-height: 100vh;
}

.vessel-list-content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}

.inner-content {
    padding: 1rem 2rem;
    flex-grow: 1;
    background-color: #f9f9f9;
}

.page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.create-button {
    padding: 6px 12px;
    font-size: 13px;
}

.view-btn {
    padding: 4px 8px;
    background-color: #007bff;
    color: #fff;
    border: none;
    font-size: 13px;
    cursor: pointer;
}

    .view-btn:hover {
        background-color: #0056b3;
    }
`, "",{"version":3,"sources":["webpack://./src/pages/demo/Vessel/VesselRegistration.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;IACI,aAAa;IACb,aAAa;IACb,yBAAyB;AAC7B;;IAEI,oCAAoC;IACpC;QACI,YAAY;QACZ,cAAc;QACd,yBAAyB;QACzB,aAAa;QACb,gBAAgB;IACpB;;IAEA,qCAAqC;IACrC;QACI,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,iBAAiB;QACjB,kBAAkB;QAClB,sBAAsB;QACtB,gBAAgB;IACpB;;AAEJ,iBAAiB;AACjB;IACI,aAAa;IACb,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;AACnB;;IAEI;QACI,mBAAmB;QACnB,WAAW;QACX,qBAAqB;IACzB;;AAEJ;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,SAAS;AACb;;AAEA,oBAAoB;AACpB;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA,qBAAqB;AACrB;IACI;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;AACJ;AACA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6B;AACjC;;IAEI;QACI,eAAe;QACf,cAAc;QACd,mBAAmB;QACnB,8BAA8B;QAC9B,kBAAkB;IACtB;;AAEJ;IACI,aAAa;IACb,2DAA2D;IAC3D,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;AACvB;;IAEI;;QAEI,iBAAiB;QACjB,gBAAgB;QAChB,sBAAsB;QACtB,kBAAkB;IACtB;;AAEJ;IACI,WAAW;IACX,yBAAyB;AAC7B;;IAEI;;QAEI,aAAa;QACb,sBAAsB;QACtB,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,yBAAyB;QACzB,gBAAgB;IACpB;;AAEJ;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;IAEI;;QAEI,YAAY;QACZ,gBAAgB;QAChB,eAAe;IACnB;;AAEJ;IACI,WAAW;IACX,yBAAyB;IACzB,sBAAsB;AAC1B;;IAEI;QACI,sBAAsB;QACtB,aAAa;QACb,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;QACzB,iBAAiB;IACrB;;IAEA;QACI,yBAAyB;IAC7B;AACJ;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;IAEI;QACI,yBAAyB;IAC7B","sourcesContent":["/* === Layout fix === */\n.vessel-registration-layout {\n    display: flex;\n    height: 100vh;\n    background-color: #f5f8fc;\n}\n\n    /* Sidebar should have fixed width */\n    .vessel-registration-layout .sidebar {\n        width: 250px;\n        flex-shrink: 0;\n        background-color: #e6ddcf;\n        height: 100vh;\n        overflow-y: auto;\n    }\n\n    /* Main section should grow to fill */\n    .vessel-registration-layout .main-content {\n        flex-grow: 1;\n        display: flex;\n        flex-direction: column;\n        min-height: 100vh;\n        padding: 16px 24px;\n        box-sizing: border-box;\n        overflow-y: auto;\n    }\n\n/* === Tabs === */\n.tab-navigation {\n    display: flex;\n    flex-wrap: wrap;\n    margin: 16px 0;\n    gap: 10px;\n}\n\n.tab-item {\n    padding: 10px 16px;\n    background: #fff;\n    border-radius: 4px;\n    cursor: pointer;\n    border: 1px solid #ddd;\n    font-weight: 500;\n    font-size: 14px;\n}\n\n    .tab-item.active {\n        background: #16375c;\n        color: #fff;\n        border-color: #16375c;\n    }\n\n.tab-content {\n    background: #fff;\n    padding: 24px;\n    border-radius: 6px;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n    margin-bottom: 30px;\n}\n\n.tab-buttons {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 24px;\n    gap: 12px;\n}\n\n/* === Buttons === */\n.btn-primary {\n    background-color: #16375c;\n    color: white;\n    padding: 8px 20px;\n    border: none;\n    border-radius: 4px;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.btn-secondary {\n    background-color: #e0e0e0;\n    color: #333;\n    padding: 8px 20px;\n    border: none;\n    border-radius: 4px;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n/* Responsive Fixes */\n@media (max-width: 768px) {\n    .tab-item {\n        flex: 1 1 100%;\n        text-align: center;\n    }\n\n    .tab-buttons {\n        flex-direction: column;\n        align-items: stretch;\n    }\n}\n.review-section {\n    margin-bottom: 32px;\n    padding-bottom: 16px;\n    border-bottom: 1px solid #ccc;\n}\n\n    .review-section h3 {\n        font-size: 20px;\n        color: #16375c;\n        margin-bottom: 12px;\n        border-left: 4px solid #16375c;\n        padding-left: 12px;\n    }\n\n.review-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n    gap: 12px 24px;\n}\n\n.review-field {\n    font-size: 14px;\n}\n\n.review-label {\n    font-weight: 600;\n    color: #333;\n}\n\n.review-value {\n    color: #555;\n}\n.main-layout {\n    display: flex;\n    flex-direction: row;\n    min-height: 100vh;\n}\n\n.main-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    background-color: #f4f7fa;\n    padding: 20px;\n    overflow-x: hidden;\n}\n\n.content-card {\n    background: white;\n    padding: 20px;\n    border-radius: 8px;\n    margin-top: 10px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);\n}\n\n.filter-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin-bottom: 20px;\n}\n\n    .filter-row input,\n    .filter-row select {\n        padding: 8px 12px;\n        min-width: 180px;\n        border: 1px solid #ccc;\n        border-radius: 4px;\n    }\n\n.vessel-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n    .vessel-table th,\n    .vessel-table td {\n        padding: 10px;\n        border: 1px solid #ccc;\n        text-align: left;\n        font-size: 14px;\n    }\n\n    .vessel-table th {\n        background-color: #f0f0f0;\n        font-weight: 600;\n    }\n\n.pagination-controls {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 16px;\n    margin-top: 20px;\n}\n.vessel-list-page {\n    padding: 1rem 2rem;\n    background-color: #f9f9f9;\n}\n\n.filter-grid {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    margin-bottom: 1rem;\n}\n\n    .filter-grid input,\n    .filter-grid select {\n        padding: 8px;\n        min-width: 180px;\n        font-size: 14px;\n    }\n\n.vessel-table {\n    width: 100%;\n    border-collapse: collapse;\n    background-color: #fff;\n}\n\n    .vessel-table th, .vessel-table td {\n        border: 1px solid #ddd;\n        padding: 10px;\n        font-size: 14px;\n        text-align: left;\n    }\n\n    .vessel-table th {\n        background-color: #f0f0f0;\n        font-weight: bold;\n    }\n\n    .vessel-table tbody tr:hover {\n        background-color: #f5f5f5;\n    }\n.vessel-list-layout {\n    display: flex;\n    min-height: 100vh;\n}\n\n.vessel-list-content {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n}\n\n.inner-content {\n    padding: 1rem 2rem;\n    flex-grow: 1;\n    background-color: #f9f9f9;\n}\n\n.page-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.create-button {\n    padding: 6px 12px;\n    font-size: 13px;\n}\n\n.view-btn {\n    padding: 4px 8px;\n    background-color: #007bff;\n    color: #fff;\n    border: none;\n    font-size: 13px;\n    cursor: pointer;\n}\n\n    .view-btn:hover {\n        background-color: #0056b3;\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
